import {PrAxleConfigurationType} from "@/modules/perRoad/interfaces/perRoad";
import {IPrTireLoadImperial} from "@/modules/perRoad/interfaces/monteCarlo";
import {UnitSystem} from "@/interfaces/units";

export const legacyAxlePatterns = {
  "3S2": [
    {
      location: {x: 0, y: 0},
      load: 5000,
      pressure: 140,
    },
    {
      location: {x: 8, y: 0},
      load: 5000,
      pressure: 140,
    },
    {
      location: {x: 84, y: 0},
      load: 5000,
      pressure: 140,
    },
    {
      location: {x: 92, y: 0},
      load: 5000,
      pressure: 140,
    },
    {
      location: {x: 4, y: 300},
      load: 8000,
      pressure: 140,
    },
    {
      location: {x: 88, y: 300},
      load: 8000,
      pressure: 140,
    }],
  "Typical Steer Axle": [
    {
      location: {x: 0, y: 0},
      load: 7200,
      pressure: 120,
    },
    {
      location: {x: 82, y: 0},
      load: 7200,
      pressure: 120,
    },
  ],
  "Typical Single Axle with Dual Tires": [{
    location: {x: 0, y: 0},
    load: 5000,
    pressure: 100,
  }, {
    location: {x: 12.6, y: 0},
    load: 5000,
    pressure: 100,
  }, {
    location: {x: 77.4, y: 0},
    load: 5000,
    pressure: 100,
  }, {
    location: {x: 90, y: 0},
    load: 5000,
    pressure: 100,
  }],
  "Typical Tandem with Single Tires": [{
    location: {x: 0, y: 0},
    load: 8500,
    pressure: 100,
  }, {
    location: {x: 80.5, y: 0},
    load: 8500,
    pressure: 100,
  }, {
    location: {x: 0, y: 54},
    load: 8500,
    pressure: 100,
  }, {
    location: {x: 80.5, y: 54},
    load: 8500,
    pressure: 100,
  }],
  "Typical Tandem with Dual Tires": [{
    location: {x: 0, y: 0},
    load: 4250,
    pressure: 100,
  }, {
    location: {x: 12.6, y: 0},
    load: 4250,
    pressure: 100,
  }, {
    location: {x: 77.4, y: 0},
    load: 4250,
    pressure: 100,
  }, {
    location: {x: 90, y: 0},
    load: 4250,
    pressure: 100,
  }, {
    location: {x: 0, y: 54},
    load: 4250,
    pressure: 100,
  }, {
    location: {x: 12.6, y: 54},
    load: 4250,
    pressure: 100,
  }, {
    location: {x: 77.4, y: 54},
    load: 4250,
    pressure: 100,
  }, {
    location: {x: 90, y: 54},
    load: 4250,
    pressure: 100,
  }],
  "Typical Tridem with Dual Tires": [{
    location: {x: 0, y: 0},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 12.6, y: 0},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 77.4, y: 0},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 90, y: 0},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 0, y: 48},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 12.6, y: 48},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 77.4, y: 48},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 90, y: 48},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 0, y: 96},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 12.6, y: 96},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 77.4, y: 96},
    load: 3500,
    pressure: 100,
  }, {
    location: {x: 90, y: 96},
    load: 3500,
    pressure: 100,
  }],
};


// Contact patch radius!!! Not tire rolling radius!!!

export const axlePatterns: { [index: string]: { [index: string]: IPrTireLoadImperial[] } } = {
  [PrAxleConfigurationType.STEER]: {
    singleTire: [
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 0, y: 0},
        criticalLayout_in: [
          {x: 0, y: 0}
        ],
        load_lbf: 7200,
        tirePressure_psi: 100,
      },
    ],
  },
  [PrAxleConfigurationType.SINGLE]: {
    singleTire: [
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 0, y: 0},
        criticalLayout_in: [
          {x: 0, y: 0}
        ],
        load_lbf: 7200,
        tirePressure_psi: 100,
      },
    ],
    doubleTire: [
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 0, y: 0},
        criticalLayout_in: [
          {x: 0, y: 0},
          {x: 6.75, y: 0}
        ],
        load_lbf: 4250,
        tirePressure_psi: 100,
      },
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 13.5, y: 0},
        criticalLayout_in: [],
        load_lbf: 4250,
        tirePressure_psi: 100,
      },
    ],
  },

  [PrAxleConfigurationType.TANDEM]: {
    doubleTire: [
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 0, y: 0},
        criticalLayout_in: [
          {x: 0, y: 0},
          {x: 6.75, y: 0},
          {x: 0, y: 27},
          {x: 6.75, y: 27}
        ],
        load_lbf: 4250,
        tirePressure_psi: 100,
      },
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 13.5, y: 0},
        criticalLayout_in: [],
        load_lbf: 4250,
        tirePressure_psi: 100,
      },
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 0, y: 54},
        criticalLayout_in: [],
        load_lbf: 4250,
        tirePressure_psi: 100,
      },
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 13.5, y: 54},
        criticalLayout_in: [],
        load_lbf: 4250,
        tirePressure_psi: 100,
      },
    ],
  },
  [PrAxleConfigurationType.TRIDEM]: {
    doubleTire: [
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {x: 0, y: 0},
        criticalLayout_in: [
          {x: 0, y: 0},
          {x: 6.75, y: 0},
          {x: 0, y: 27},
          {x: 6.75, y: 27},
          {x: 6.75, y: 54}
        ],
        load_lbf: 3500,
        tirePressure_psi: 100,
      },
      {
        unitSystem: UnitSystem.Imperial,
        location_in: {
          x: 0,
          y: 54
        },
        criticalLayout_in: [],
        load_lbf: 3500,
        tirePressure_psi: 100,
      },

      {
        unitSystem: UnitSystem.Imperial,
        location_in: {
          x: 0,
          y: 108
        },
        criticalLayout_in: [],
        load_lbf: 3500,
        tirePressure_psi: 100,
      },

      {
        unitSystem: UnitSystem.Imperial,
        location_in: {
          x: 13.5,
          y: 0
        },
        criticalLayout_in: [],
        load_lbf: 3500,
        tirePressure_psi: 100,
      },

      {
        unitSystem: UnitSystem.Imperial,
        location_in: {
          x: 13.5,
          y: 54
        },
        criticalLayout_in: [],
        load_lbf: 3500,
        tirePressure_psi: 100,
      },

      {
        unitSystem: UnitSystem.Imperial,
        location_in: {
          x: 13.5,
          y: 108
        },
        criticalLayout_in: [],
        load_lbf: 3500,
        tirePressure_psi: 100,
      },
    ],
  },
};

export const loadingPatternOptions = {
  "Single Axle, Single Tire": axlePatterns[PrAxleConfigurationType.SINGLE].singleTire,
  "Single Axle, Double Tire": axlePatterns[PrAxleConfigurationType.SINGLE].doubleTire,
  "Tandem Axle, Double Tire": axlePatterns[PrAxleConfigurationType.TANDEM].doubleTire,
  "Tridem Axle, Double Tire": axlePatterns[PrAxleConfigurationType.TRIDEM].doubleTire,
};
